import { render, staticRenderFns } from "./WarrantTerms.vue?vue&type=template&id=8bdc2a20&scoped=true&"
import script from "./WarrantTerms.js?vue&type=script&lang=js&"
export * from "./WarrantTerms.js?vue&type=script&lang=js&"
import style0 from "./WarrantTerms.vue?vue&type=style&index=0&id=8bdc2a20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bdc2a20",
  null
  
)

export default component.exports